export const getCurrentTime = () => {
  var d = new Date();
  return d.getTime() / 1000;
};
